import React from 'react';
import {
  MapPin, Sparkles, Utensils, ChefHat, Coffee, Monitor, Keyboard,
  ShoppingBag, Store, BookOpen, GraduationCap, Wrench,
  HardHat, Zap, Scissors, Trophy, Dumbbell, Briefcase,
} from 'lucide-react';
import { jobTitle } from '../constants/jobOptions';
import './SwipeCard.css';

const THEMES = {
  Gastronomie:  { bg: '#6B2338', Icon: Utensils },
  Restaurant:   { bg: '#6B2338', Icon: Utensils },
  Küche:        { bg: '#6B2338', Icon: ChefHat },
  Service:      { bg: '#6B2338', Icon: Utensils },
  Café:         { bg: '#6B2338', Icon: Coffee },
  Technologie:  { bg: '#0E1F3A', Icon: Monitor },
  IT:           { bg: '#0E1F3A', Icon: Monitor },
  Software:     { bg: '#0E1F3A', Icon: Keyboard },
  Digital:      { bg: '#0E1F3A', Icon: Monitor },
  Handel:       { bg: '#163324', Icon: ShoppingBag },
  Einzelhandel: { bg: '#163324', Icon: ShoppingBag },
  Supermarkt:   { bg: '#163324', Icon: Store },
  Markt:        { bg: '#163324', Icon: Store },
  Bildung:      { bg: '#122055', Icon: BookOpen },
  Schule:       { bg: '#122055', Icon: GraduationCap },
  Ausbildung:   { bg: '#122055', Icon: BookOpen },
  Lehrer:       { bg: '#122055', Icon: GraduationCap },
  Handwerk:     { bg: '#42200F', Icon: Wrench },
  Bau:          { bg: '#42200F', Icon: HardHat },
  Elektriker:   { bg: '#42200F', Icon: Zap },
  Sanitär:      { bg: '#42200F', Icon: Wrench },
  Tischler:     { bg: '#42200F', Icon: Scissors },
  Sport:        { bg: '#1C1F2A', Icon: Trophy },
  Fitness:      { bg: '#1C1F2A', Icon: Dumbbell },
  Freizeit:     { bg: '#1C1F2A', Icon: Trophy },
  Trainer:      { bg: '#1C1F2A', Icon: Dumbbell },
};

const DEFAULT_THEME = { bg: '#1A2840', Icon: Briefcase };

function getTheme(job) {
  const search = ((job.category || '') + ' ' + (job.title || '')).toLowerCase();
  for (const [key, theme] of Object.entries(THEMES)) {
    if (search.includes(key.toLowerCase())) return theme;
  }
  return DEFAULT_THEME;
}

function SwipeCard({ job }) {
  const { bg, Icon } = getTheme(job);

  return (
    <div className="swipe-card" style={{ background: bg }}>
      <div className="swipe-card__icon-area">
        <Icon size={56} strokeWidth={1.2} color="rgba(255,255,255,0.9)" />
      </div>
      <div className="swipe-card__info">
        <p className="swipe-card__company">{job.company}</p>
        <h2 className="swipe-card__title">{jobTitle(job.title)}</h2>
        <div className="swipe-card__meta">
          {job.location && (
            <span className="swipe-card__location">
              <MapPin size={13} />
              {job.location}
            </span>
          )}
          {job.type && (
            <span className="swipe-card__badge">{job.type}</span>
          )}
          {job.salary && (
            <span className="swipe-card__salary">{job.salary}</span>
          )}
          {/* Vom Backend bei wishes=1: erfüllt etwa 70 % der Wünsche aus dem Profil */}
          {job.matches_wishes && (
            <span className="swipe-card__badge swipe-card__badge--match">
              <Sparkles size={11} /> Passt zu dir
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// Nur neu rendern, wenn sich der Job ändert
export default React.memo(SwipeCard, (prev, next) => prev.job?.id === next.job?.id);
